import { Box, Button, FormControl, IconButton, InputLabel, MenuItem, Select, Stack, TextField, Tooltip, Typography } from "@mui/material"
import Table from "../custom/Table"
import Modal from "../Modals"
import { RGP_TABLE, MyObject, IStoUpdate, RGP_LINEITEM_MODAL, IRGPUpdate, RGP_ACK_LINEITEM_MODAL } from "../../Models/Inventory"
import { useCallback, useContext, useEffect, useState } from "react"
import { GridColDef, GridFilterModel } from "@mui/x-data-grid"
import VisibilityIcon from '@mui/icons-material/Visibility';
import CreateRGPModal from "./CreateRGPModal"
import styled from "styled-components"
import Title from "../custom/Title"
import { AuthContext } from "../../contexts/AuthContext"
import { InventoryContext } from "../../contexts/InventoryContext"
import useService from "../../hooks/useService"
import { updateAWBNumber, getRGPChallanInvoice, getRGPRows, getRGPLineItems, cancelRGPTransfer, acknowledgeRGPOrder } from "../../services/Inventory"
import { NotificationContext } from "../../contexts/NotificationContext";
import { ShowSerialNumbers, getInventoryType } from "./InventoryShowcase"
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DownloadIcon from '@mui/icons-material/Download';
import moment from "moment"
import { getFormattedCurrency } from '../../utils/helpers'
import { DOCUMENT_TYPES } from "../../utils/constant"

const MetalImage = styled.img`
  object-fit: contain;
  max-width: 100px;
  max-height: 45px;
  border-radius: 4px;
  padding: 3px 0;
`
let rgpOrderStatus: any = {
    '0': 'Pending/In Transit',
    '1': 'Received',
    '2': 'Cancelled'
}

const StatusModal = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 15px;
  width: 800px
`

const RGPManagement = () => {
    const { execute } = useService()
    const { user } = useContext(AuthContext)
    const { notify } = useContext(NotificationContext);
    const { rgpInventoryRows, inventories } = useContext(InventoryContext)
    const [showLineItemDetail, setShowLineItemDetail] = useState<boolean>(false)
    const [lineItemDetails, setLineItemDetails] = useState("")
    const [showRGPModal, setShowRGPModal] = useState<boolean | string>(false)
    const [linedItemModalHeading, setLinedItemModalHeading] = useState<string>('');
    const [STOEditModalData, setRGPEditModalData] = useState<boolean | string>(false)

    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 })
    const [filterModel, setFilterModel] = useState<GridFilterModel>({
        items: []
    })

    const closeRGPModal = () => {
        setShowRGPModal(false)
    }

    const closeRGPEditModal = () => {
        setRGPEditModalData(false)
    }

    const closeAcknowledgeModal = () => {
        setShowLineItemDetail(false)
    }

    const HandleLineItemModal = (params: any, heading: string) => {
        setLinedItemModalHeading(heading);
        setShowLineItemDetail(params.requestedSkuDetail);
        setLineItemDetails(params.rgpId);
    }

    const getRGPInvoice = async (rgpId: string, invoiceType: string) => {
        const { data, error } = await execute(() => getRGPChallanInvoice({ rgpId, type: invoiceType }))
        if (data) window.open(data?.url, '_blank')
    }

    const getRGPInventoryColumns = () => {
        let minWidth = 100

        return RGP_TABLE.map(inboundField => {

            const row: GridColDef = {
                field: inboundField.id,
                headerName: inboundField.label,
                minWidth,
                headerAlign: 'left',
                align: 'left'
            }

            switch (inboundField.id) {
                case "rgpId":
                    row.minWidth = 120;
                    row.type = 'string';
                    row.renderCell = params => {
                        return params.row.rgpId ? params.row.rgpId : "NA"
                    }
                    break;
                case "downloadInvoice":
                    row.minWidth = 180;
                    row.filterable = false;
                    row.align = 'center'
                    row.renderCell = params => {
                        return (
                            <>
                                <Tooltip title={'Download DC'}>
                                    <IconButton style={{ marginLeft: '-10px' }} onClick={() => getRGPInvoice(params.row.rgpId, DOCUMENT_TYPES.DELIVERY_CHALLAN)}>
                                        <DownloadIcon fontSize="medium" />
                                    </IconButton>
                                </Tooltip>
                            </>
                        )
                    }
                    break;
                case "createdAt":
                    row.minWidth = 200;
                    row.type = 'dateTime';
                    row.valueGetter = params => {
                        return params.row.createdAt && new Date(params.row.createdAt)
                    }
                    break;
                case "updatedAt":
                    row.minWidth = 200;
                    row.type = 'dateTime';
                    row.valueGetter = params => {
                        return params.row.updatedAt && new Date(params.row.updatedAt)
                    }
                    break;
                case "status":
                    row.minWidth = 150;
                    row.type = 'string';
                    row.renderCell = params => {
                        return rgpOrderStatus[params.row.status]
                    }
                    break;
                case "customerName":
                    row.minWidth = 200;
                    row.type = 'string';
                    row.renderCell = params => {
                        return (
                            <Tooltip title={params.row.customerName}>
                                <Typography>{params.row.customerName}</Typography>
                            </Tooltip>
                        )
                    }
                    break;
                case "billingAddress":
                    row.minWidth = 350;
                    row.type = 'string';
                    row.renderCell = params => {
                        let address = params.row.billingAddress
                        return (
                            <Tooltip title={address}>
                                <Typography>{address.length > 40 ? address.slice(0, 40) + '...' : address}</Typography>
                            </Tooltip>
                        )
                    }
                    break;
                case "deliveryChallanNo":
                    row.minWidth = 200;
                    row.type = 'string';
                    row.renderCell = params => {
                        let deliveryChallanNo = params.row.deliveryChallanNo ? params.row.deliveryChallanNo : "NA"
                        return (
                            <Tooltip title={deliveryChallanNo}>
                                <Typography>{deliveryChallanNo}</Typography>
                            </Tooltip>
                        )
                    }
                    break;
                case "totalGoldWeight":
                    row.minWidth = 150;
                    row.type = 'number';
                    row.renderCell = params => {
                        return params.row.totalGoldWeight ? params.row.totalGoldWeight.toFixed(3) : "NA"
                    }
                    break;
                case "totalGoldFineWeight":
                    row.minWidth = 150;
                    row.type = 'number';
                    row.renderCell = params => {
                        return params.row.totalGoldFineWeight ? params.row.totalGoldFineWeight.toFixed(3) : "NA"
                    }
                    break;
                case "totalSilverWeight":
                    row.minWidth = 150;
                    row.type = 'number';
                    row.renderCell = params => {
                        return params.row.totalSilverWeight ? params.row.totalSilverWeight.toFixed(3) : "NA"
                    }
                    break;
                case "totalSilverFineWeight":
                    row.minWidth = 150;
                    row.type = 'number';
                    row.renderCell = params => {
                        return params.row.totalSilverFineWeight ? params.row.totalSilverFineWeight.toFixed(3) : "NA"
                    }
                    break;
                case "fullName":
                    row.minWidth = 200;
                    row.type = 'string';
                    row.renderCell = params => {
                        return (
                            <Tooltip title={params.row.fullName ? params.row.fullName : "NA"}>
                                <Typography>{params.row.fullName ? params.row.fullName : "NA"}</Typography>
                            </Tooltip>
                        )
                    }
                    break;
                case "remarks":
                    row.minWidth = 220;
                    row.type = 'string';
                    row.renderCell = params => {
                        return (
                            <Tooltip title={params.row.remarks ? params.row.remarks : "NA"}>
                                <Typography>{params.row.remarks ? params.row.remarks : "NA"}</Typography>
                            </Tooltip>
                        )
                    }
                    break;
                case "acknowledgementRemarks":
                    row.minWidth = 300;
                    row.type = 'string';
                    row.renderCell = params => {
                        let acknowledgementRemarks = params.row.acknowledgementRemarks ? params.row.acknowledgementRemarks : "NA"
                        return (
                            <Tooltip title={acknowledgementRemarks}>
                                <Typography>{acknowledgementRemarks}</Typography>
                            </Tooltip>
                        )
                    }
                    break;
                case "acknowledgedAt":
                    row.minWidth = 200;
                    row.type = 'dateTime';
                    row.valueGetter = params => {
                        return params.row.acknowledgedAt && new Date(params.row.acknowledgedAt)
                    }
                    break;
                case "grossRate":
                    row.minWidth = 150;
                    row.type = 'number';
                    row.renderCell = params => {
                        return params.row.grossRate ? getFormattedCurrency(params.row.grossRate, true) : "NA"
                    }
                    break;
                case "invoiceGrandTotal":
                    row.minWidth = 150;
                    row.type = 'number';
                    row.renderCell = params => {
                        return params.row.invoiceGrandTotal ? getFormattedCurrency(params.row.invoiceGrandTotal, true) : "NA"
                    }
                    break;
                case "lineItem":
                    row.minWidth = 150;
                    row.filterable = false;
                    row.align = 'center'
                    row.renderCell = params => {
                        return <>
                            <Tooltip title='View line item details'>
                                <IconButton style={{ marginLeft: '-10px' }} onClick={() => HandleLineItemModal(params.row, params.row.rgpId)}><VisibilityIcon /></IconButton>
                            </Tooltip>
                        </>
                    }
                    break;
                case "actions":
                    row.minWidth = 150;
                    row.filterable = false;
                    row.renderCell = params => {
                        let orderCancelled = parseInt(params.row.status) === 0
                        return (
                            <>{orderCancelled ?
                                <>
                                    <Tooltip title={'Acknowledge RGP'}>
                                        <IconButton style={{ marginLeft: '-10px' }} onClick={() => setRGPEditModalData(params.row)}>
                                            <CheckCircleIcon />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title={'Cancel RGP transfer'}>
                                        <IconButton style={{ marginLeft: '-10px' }} disabled={!orderCancelled} onClick={() => handleCalcelRGPTransfer(params.row.rgpId)}>
                                            <CancelIcon />
                                        </IconButton>
                                    </Tooltip>
                                </>
                                : "NA"}
                            </>)
                    }
                    break;
                default:
                    row.minWidth = 100
                    break;
            }
            return row;
        })
    }

    const handleCalcelRGPTransfer = async (rgpId: string) => {
        const { data, error } = await execute(() => cancelRGPTransfer({ rgpId, centerId: user.centerId || '' }))

        if (!error) {
            notify('Cancelled RGP transfer')
            reloadRGPData()
        }
    }

    const reloadRGPData = () => {
        let body = {
            channelId: user.centerId,
            page: paginationModel.page,
            pageSize: paginationModel.pageSize,
            filterModel: filterModel
        }
        execute(() => getRGPRows(body));
    }

    const onFilterChange = useCallback((filterModel: GridFilterModel) => {
        setFilterModel(filterModel)
    }, [])

    useEffect(() => {
        reloadRGPData()
    }, [paginationModel, filterModel.items[0]?.value])

    return (
        <div style={{ padding: "15px 0px 0px 0px" }}>
            <div style={{ borderBottom: '1px solid #d8d8d8', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Title style={{ textAlign: 'left', margin: '20px 10px 10px 10px', color: '#7f7d76' }}>RGP Management</Title>
                <Button color="primary" variant='contained' disabled={!inventories?.data} onClick={() => setShowRGPModal('true')}>{'Create RGP'}</Button>
            </div>

            <Table
                paginationMode={"server"}
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                getRowId={(row) => row.rgpId}
                columns={getRGPInventoryColumns()}
                rows={rgpInventoryRows?.data || []}
                hideFooter={false}
                rowCount={rgpInventoryRows?.count || 0}
                filterMode='server'
                filterDebounceMs={1000}
                onFilterModelChange={onFilterChange}
                disableRowSelectionOnClick={true}
                pageSizeOptions={[10, 50, 100]}
            />

            <Modal open={typeof showLineItemDetail != 'boolean'} title={linedItemModalHeading} onClose={setShowLineItemDetail} maxWidth={'xl'}>
                <LineItemDetailModal lineItemDetails={lineItemDetails} onClose={closeAcknowledgeModal} />
            </Modal>

            <Modal open={typeof showRGPModal != 'boolean'} title={'Create new RGP'} onClose={closeRGPModal} maxWidth='xl'>
                <CreateRGPModal onClose={closeRGPModal} reloadRGPData={reloadRGPData} />
            </Modal>

            <Modal open={typeof STOEditModalData != 'boolean'} title={'Acknowledge RGP'} onClose={closeRGPEditModal} maxWidth="md">
                <UpdateRGPStatusModal onClose={closeRGPEditModal} rgpInventoryRows={rgpInventoryRows} data={STOEditModalData} reload={reloadRGPData} />
            </Modal>
        </div>
    )
}

function LineItemDetailModal({ lineItemDetails, onClose }: { lineItemDetails?: any, onClose: Function }) {
    const { execute } = useService()
    const { rgpLineItems } = useContext(InventoryContext)
    const [lineSerialNumbers, setLineSerialNumbers] = useState(false);

    const closeSerialNumbersModal = () => {
        setLineSerialNumbers(false)
    }

    const getLineItemColumns = () => {
        let minWidth = 100

        return RGP_LINEITEM_MODAL.map(field => {

            const row: GridColDef = {
                field: field.id,
                headerName: field.label,
                minWidth,
                align: 'left'
            }

            switch (field.id) {
                case "imageURL":
                    row.minWidth = 100;
                    row.renderCell = params => {
                        let url = params.row.imageURL?.length > 0 ? params.row.imageURL?.sort((a: MyObject, b: MyObject) => a.priority - b.priority)[0].img_url : ''
                        return url ? <MetalImage src={url} /> : <MetalImage src={'/assets/images/elementor-placeholder-image.webp'} />
                    }
                    break;
                case "name":
                    row.minWidth = 550;
                    row.renderCell = params => {
                        let productName;
                        if (params.row.inventoryType === 1 || params.row.inventoryType === 2 || params.row.inventoryType === 7) {
                            productName = params.row.name;
                        }
                        return (
                            <Tooltip title={productName}>
                                <Typography>{productName}</Typography>
                            </Tooltip>
                        )
                    }
                    break;
                case "inventoryType":
                    row.minWidth = 200;
                    row.renderCell = params => {
                        return getInventoryType(params.row)
                    }
                    break;
                case "skuId":
                    row.minWidth = 200;
                    row.renderCell = params => {
                        let skuId = params.row.skuId ? params.row.skuId : 'NA'
                        return (
                            <Tooltip title={skuId}>
                                <Typography>{skuId}</Typography>
                            </Tooltip>
                        )
                    }
                    break;
                case "fineWeight":
                    row.minWidth = 100;
                    row.renderCell = params => {
                        return params.row.fineWeight ? params.row.fineWeight : "NA"
                    }
                    break;
                case "weight":
                    row.minWidth = 100;
                    row.renderCell = params => {
                        return params.row.weight ? params.row.weight.toFixed(3) : "NA"
                    }
                    break;
                case "purity":
                    row.minWidth = 100;
                    row.renderCell = params => {
                        return params.row.purity ? params.row.purity : "NA"
                    }
                    break;
                case "metalType":
                    row.minWidth = 150;
                    row.renderCell = params => {
                        return params.row.metalType ? params.row.metalType : "NA"
                    }
                    break;
                case "serialNumbers":
                    row.minWidth = 150;
                    row.renderCell = params => {
                        let shouldIconBeShown = (params.row.inventoryType === 1) && params.row.serialNumbers
                        return <>
                            {shouldIconBeShown ?
                                <Tooltip title='View Serial Numbers'>
                                    <IconButton style={{ marginLeft: '-10px' }} onClick={() => setLineSerialNumbers({ ...params.row, unitWeight: params.row.weight, serialNumbers: JSON.stringify(params.row.serialNumbers) })}><VisibilityIcon /></IconButton>
                                </Tooltip>
                                :
                                "NA"
                            }
                        </>
                    }
                    break;
                default:
                    row.minWidth = 100
                    break;
            }
            return row;
        })
    }

    useEffect(() => {
        let body = {
            rgpId: lineItemDetails
        }
        execute(() => getRGPLineItems(body));
    }, [])

    return (
        <div style={{ width: "80vw" }}>
            <Table
                getRowId={(row) => row.id}
                columns={getLineItemColumns()}
                rows={rgpLineItems}
                hideFooter={false}
            />

            <Modal open={typeof lineSerialNumbers != 'boolean'} title={"Serial Numbers"} onClose={closeSerialNumbersModal} maxWidth={'xl'}>
                <ShowSerialNumbers data={lineSerialNumbers} />
            </Modal>
        </div>
    )
}

function UpdateRGPStatusModal({ onClose, rgpInventoryRows, data, reload }: { onClose: any, rgpInventoryRows: any, data: any, reload: any }) {
    let { rgpId } = data
    const { notify } = useContext(NotificationContext);
    const { execute } = useService()
    const [acknowledgeRemark, setAcknowledgeRemark] = useState<string>('')
    const [lineSerialNumbers, setLineSerialNumbers] = useState(false);
    const [customerInvoiceNo, setCustomerInvoiceNo] = useState<string>('')

    const lineItems = rgpInventoryRows.data.length && rgpInventoryRows.data.find((data: any) => data.rgpId === rgpId)?.lineItems || []
    console.log('lineItems ::', lineItems)

    const closeSerialNumbersModal = () => {
        setLineSerialNumbers(false)
    }

    const getLineItemColumns = () => {
        let minWidth = 100

        return RGP_ACK_LINEITEM_MODAL.map(field => {

            const row: GridColDef = {
                field: field.id,
                headerName: field.label,
                minWidth,
                align: 'left'
            }

            switch (field.id) {
                case "name":
                    row.minWidth = 300;
                    row.renderCell = params => {
                        let productName;
                        if (params.row.inventoryType === 1 || params.row.inventoryType === 7) {
                            productName = params.row.name;
                        }
                        return (
                            <Tooltip title={productName}>
                                <Typography>{productName.length > 35 ? productName.slice(0, 35) + '...' : productName}</Typography>
                            </Tooltip>
                        )
                    }
                    break;
                case "skuId":
                    row.minWidth = 200;
                    row.renderCell = params => {
                        let skuId = params.row.skuId ? params.row.skuId : 'NA'
                        return (
                            <Tooltip title={skuId}>
                                <Typography>{skuId}</Typography>
                            </Tooltip>
                        )
                    }
                    break;
                case "fineWeight":
                    row.minWidth = 100;
                    row.renderCell = params => {
                        return params.row.fineWeight ? params.row.fineWeight : "NA"
                    }
                    break;
                case "weight":
                    row.minWidth = 100;
                    row.renderCell = params => {
                        return params.row.weight ? params.row.weight.toFixed(3) : "NA"
                    }
                    break;
                case "purity":
                    row.minWidth = 100;
                    row.renderCell = params => {
                        return params.row.purity ? params.row.purity : "NA"
                    }
                    break;
                case "metalType":
                    row.minWidth = 150;
                    row.renderCell = params => {
                        return params.row.metalType ? params.row.metalType : "NA"
                    }
                    break;
                case "serialNumbers":
                    row.minWidth = 150;
                    row.renderCell = params => {
                        let shouldIconBeShown = (params.row.inventoryType === 1) && params.row.serialNumbers
                        return <>
                            {shouldIconBeShown ?
                                <Tooltip title='View Serial Numbers'>
                                    <IconButton style={{ marginLeft: '-10px' }} onClick={() => setLineSerialNumbers({ ...params.row, unitWeight: params.row.weight, serialNumbers: JSON.stringify(params.row.serialNumbers) })}><VisibilityIcon /></IconButton>
                                </Tooltip>
                                :
                                "NA"
                            }
                        </>
                    }
                    break;
                default:
                    row.minWidth = 100
                    break;
            }
            return row;
        })
    }

    const updateRGPStatus = async () => {
        if (!rgpId) return

        let params = {
            rgpId: rgpId,
            acknowledgeRemark: acknowledgeRemark,
            customerInvoiceNo
        }

        const { data, error } = await execute(() => acknowledgeRGPOrder(params as unknown as IRGPUpdate))

        if (!error) {
            onClose()
            notify('RGP status updated')
            reload()
        }
    }

    return (
        <StatusModal>
            <Box sx={{ width: '100%' }}>
                <Table
                    getRowId={(row) => row.id}
                    columns={getLineItemColumns()}
                    rows={lineItems}
                    hideFooter={false}
                />
            </Box>
            <TextField
                fullWidth
                size="small"
                label="Customer Invoice No."
                value={customerInvoiceNo}
                variant="outlined"
                onChange={(e) => setCustomerInvoiceNo(e.target.value)}
                sx={{ marginTop: '25px' }}
            />
            <Stack width="100%" direction="row" gap="25px" align-items="center" margin="20px 0">
                <TextField
                    required
                    fullWidth
                    size="small"
                    label="Acknowledge remark"
                    value={acknowledgeRemark}
                    variant="outlined"
                    onChange={(e) => setAcknowledgeRemark(e.target.value)}
                    sx={{ marginTop: '10px' }}
                />
            </Stack>
            <Box sx={{ width: '100%', display: 'flex', flexDirection: 'row-reverse' }}>
                <Button color="primary" variant="contained" onClick={updateRGPStatus} disabled={!acknowledgeRemark}>Confirm</Button>
            </Box>
            <Modal open={typeof lineSerialNumbers != 'boolean'} title={"Serial Numbers"} onClose={closeSerialNumbersModal} maxWidth={'xl'}>
                <ShowSerialNumbers data={lineSerialNumbers} />
            </Modal>
        </StatusModal>
    )
}


export default RGPManagement
